import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const GridIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22.7998 3.1499H1.2002C0.786095 3.1499 0.450195 3.4858 0.450195 3.8999V20.0996C0.450195 20.5137 0.786095 20.8496 1.2002 20.8496H22.7998C23.2139 20.8496 23.5498 20.5137 23.5498 20.0996V3.8999C23.5498 3.4858 23.2139 3.1499 22.7998 3.1499ZM8.8999 14.2002V9.7998H15.0996V14.2002H8.8999ZM15.0996 15.2002V19.3496H8.8999V15.2002H15.0996ZM1.9502 9.7998H7.8999V14.2002H1.9502V9.7998ZM8.8999 8.7998V4.6499H15.0996V8.7998H8.8999ZM16.0996 9.7998H22.0498V14.2002H16.0996V9.7998ZM22.0498 8.7998H16.0996V4.6499H22.0498V8.7998ZM7.8999 4.6499V8.7998H1.9502V4.6499H7.8999ZM1.9502 15.2002H7.8999V19.3496H1.9502V15.2002ZM16.0996 19.3496V15.2002H22.0498V19.3496H16.0996Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

GridIcon.displayName = 'GridIcon';
